import { useEffect, useRef, useState } from "react";

const useAnalogClock = () => {
  const hourRef = useRef(null);
  const minuteRef = useRef(null);
  const secondRef = useRef(null);
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const seconds = now.getSeconds() + now.getMilliseconds() / 1000;
      const minutes = now.getMinutes() + seconds / 60;
      const hours = now.getHours() + minutes / 60;

      // ✅ Ensure refs are not null before accessing their styles
      if (secondRef.current && minuteRef.current && hourRef.current) {
        secondRef.current.style.transform = `rotate(${seconds * 6}deg)`;
        minuteRef.current.style.transform = `rotate(${minutes * 6}deg)`;
        hourRef.current.style.transform = `rotate(${hours * 30}deg)`;
      }

      setCurrentTime(
        now.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );

      requestAnimationFrame(updateClock);
    };

    requestAnimationFrame(updateClock);
  }, []);

  return { hourRef, minuteRef, secondRef, currentTime };
};

export default useAnalogClock;
